import * as React from 'react';
import listViewStore from 'mini-mail-list-store/lib/store/Store';
import MailListViewState from 'mini-mail-list-store/lib/store/schema/MailListViewState';
import strings from 'owa-strings/owa-mini-people-strings';
import { addAriaLiveLabel } from 'mini-accessibility';
import { GenericErrorScreen } from 'mini-error-handler/lib/components/GenericErrorScreen';
import { getIconClassName } from '@uifabric/styling/lib/index';
import { getOwaMiniCommonStrings } from 'owa-strings/owa-mini-common-strings';
import { isInSearchView } from 'mini-mail-list-store/lib/selectors/isInSearchView';
import { MailIcons } from 'mini-mail-icons';
import { MiniIcons } from 'owa-mini-icons';
import { preventModalScroll } from 'prevent-modal-scroll';
import { Spinner } from 'fabric-spinner';
import { ZeroSearch } from 'mini-search-landing-view/lib/components/ZeroSearch';

const styles = require('./MailListEmptyState.scss');
const classNames = require('classnames/bind').bind(styles);

interface MailListEmptyStateProps {
    stateType: MailListViewState;
    preListComponent?: JSX.Element;
}

class MailListEmptyState extends React.Component<MailListEmptyStateProps, {}> {
    private mailListEmptyStateElementRef = React.createRef<HTMLDivElement>();

    render() {
        const isInSearch = listViewStore.shouldShowSearchBox;
        let emptyStateElement: JSX.Element = null;

        switch (this.props.stateType) {
            case MailListViewState.Loading:
                emptyStateElement = <Spinner className={styles.icon} />;
                break;

            case MailListViewState.Empty:
                const icon = isInSearch
                    ? getIconClassName(MiniIcons.Search)
                    : getIconClassName(MailIcons.OpenFolderHorizontal);
                const term = strings.searchNoResultsTitle;
                addAriaLiveLabel(term, 'assertive');
                emptyStateElement = <span className={classNames(icon, styles.icon)} />;
                break;

            case MailListViewState.Blank:
                // Currently only used when user focuses in search box without ever committing a search
                // In this case we show a blank page
                emptyStateElement = <ZeroSearch className={styles.searchImageContainer} />;
                break;

            case MailListViewState.Error:
                const commonStrings = getOwaMiniCommonStrings();
                emptyStateElement = (
                    <GenericErrorScreen
                        screenConfig={{ title: commonStrings.mailListGenericErrorSecondaryHeader }}
                    />
                );
                break;
        }

        return (
            <div
                className={classNames(styles.mailListEmptyState, styles.virtualList, {
                    [styles.searchListEmptyState]: isInSearchView(),
                })}
                ref={this.mailListEmptyStateElementRef}>
                {this.props.preListComponent && (
                    <div className={styles.prelistblock}>{this.props.preListComponent}</div>
                )}
                {emptyStateElement}
            </div>
        );
    }
}

export default preventModalScroll(
    MailListEmptyState,
    (component: any): HTMLDivElement => component.mailListEmptyStateElementRef.current
);
